import { render, staticRenderFns } from "./MainLifeRiderWidget.vue?vue&type=template&id=e3399dfc&scoped=true"
import script from "./MainLifeRiderWidget.vue?vue&type=script&lang=js"
export * from "./MainLifeRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./MainLifeRiderWidget.vue?vue&type=style&index=0&id=e3399dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3399dfc",
  null
  
)

export default component.exports